import Papa from 'papaparse'
import * as XLSX from 'xlsx'
import type { ParsedFile } from '../types'

function parseCSVContent(text: string, fileName: string): ParsedFile {
  const result = Papa.parse<Record<string, string>>(text, {
    header: true,
    skipEmptyLines: true,
  })

  const columns = result.meta.fields ?? []
  const rows = result.data

  return {
    columns,
    rows,
    fileName,
    recordCount: rows.length,
    columnCount: columns.length,
  }
}

function parseXLSXContent(buffer: ArrayBuffer, fileName: string): ParsedFile {
  const workbook = XLSX.read(buffer, { type: 'array' })
  const firstSheet = workbook.SheetNames[0]
  const worksheet = workbook.Sheets[firstSheet]
  const jsonData = XLSX.utils.sheet_to_json<Record<string, string>>(worksheet, {
    defval: '',
  })

  const columns = jsonData.length > 0 ? Object.keys(jsonData[0]) : []

  const rows = jsonData.map((row) => {
    const mapped: Record<string, string> = {}
    for (const col of columns) {
      mapped[col] = String(row[col] ?? '')
    }
    return mapped
  })

  return {
    columns,
    rows,
    fileName,
    recordCount: rows.length,
    columnCount: columns.length,
  }
}

export async function parseFile(file: File): Promise<ParsedFile> {
  const ext = file.name.split('.').pop()?.toLowerCase()

  if (ext === 'csv') {
    const text = await file.text()
    return parseCSVContent(text, file.name)
  }

  if (ext === 'xlsx' || ext === 'xls') {
    const buffer = await file.arrayBuffer()
    return parseXLSXContent(buffer, file.name)
  }

  throw new Error(
    `Unsupported file type: .${ext}. Please upload a CSV or XLSX file.`
  )
}
